import { render, staticRenderFns } from "./leadsCharts.vue?vue&type=template&id=f44815e4&scoped=true"
import script from "./leadsCharts.vue?vue&type=script&lang=js"
export * from "./leadsCharts.vue?vue&type=script&lang=js"
import style0 from "./leadsCharts.vue?vue&type=style&index=0&id=f44815e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f44815e4",
  null
  
)

export default component.exports